/* eslint-disable indent */
import { Environment } from '../types/environment';

export const getEnvironment = (hostname: string): string => {
  const matches = /(?:(local|qa1|.+)\.)?climate.com/g.exec(
    hostname.replace(/^(https?:\/\/)?(www\.)?/, '')
  );

  if (matches) {
    const env = matches[1];
    if (matches[1]) {
      switch (env) {
        case 'local':
          return Environment.Local; // 2 spaces for the first level inside switch
        case 'qa1':
          return Environment.Qa; // 2 spaces for the first level inside switch
        default:
          return Environment.Unknown; // 2 spaces for the first level inside switch
      }
    }
    return Environment.Production;
  }

  return Environment.Unknown;
};

export const isEnv = (environment: Environment) =>
  getEnvironment(window.location.hostname) === environment;

// TODO move function to url
export const getURLFromHash = (hashRoute: string): string => {
  const currentURL = window.location.href;
  const lastIndex = currentURL.includes('#')
    ? currentURL.indexOf('#')
    : currentURL.length;
  return `${currentURL.substring(0, lastIndex)}#${hashRoute}`;
};

// TODO move function to url
export const getPageIdFromURL = (): string => {
  const { hash } = window.location;
  const baseHash = hash && hash.includes('?') ? hash.split('?')[0] : hash;
  let pageId = baseHash ? baseHash.replace('#', '') : '';

  if (pageId && pageId.indexOf('/') === 0) {
    pageId = pageId.substring(1);
  }

  if (pageId && pageId.includes('/')) {
    const splitIndex = pageId.indexOf('/');
    [pageId] = pageId.split(pageId[splitIndex]);
  }
  return pageId;
};
